import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faDownload, faEye, faMoneyBill, faPen, faRecycle, faTrash, faBolt, faDollarSign, faExclamationTriangle, faWallet, faMoneyBillWave, faSackDollar } from '@fortawesome/free-solid-svg-icons';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { CircularProgress, TablePagination, Tooltip } from "@mui/material";
import ExportDropdownMenu from '../../../base-components/ExportDropdownMenu';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';

import React, { useEffect, useState, useMemo } from 'react';

import { useNavigate } from 'react-router-dom';

import { filterMembers } from '../reports/member_reports/member';
import TablePaginationActions from '../../../base-components/TablePaginationActions';

import RenderFilters from './RenderFilters';
import RenderFiltersType from './RenderFiltersType';
import defaultUser from '../../../images/user_default.jpg'
import { number } from 'yup';
import dayjs from "dayjs";

import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RestoreIcon from "@mui/icons-material/Restore";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PaidIcon from "@mui/icons-material/Paid";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import WalletIcon from "@mui/icons-material/AccountBalanceWallet";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import LockResetIcon from '@mui/icons-material/LockReset';
import { encodedImagesURI } from '../../../utils/helpers';
import { sortMembers } from '../../../utils/memberTableSort';
import { StatusChip, EmptyState, initials } from '../../../ui';
import { getSessionUser, hasPermission } from '../../../utils/roleAccess';
import { memberFeeChip } from '../../../utils/memberFeeStatus';

const SORT_OPTIONS = [
  { key: 'name', label: 'Name' },
  { key: 'member_id', label: 'Member ID' },
  { key: 'phone', label: 'Phone' },
  { key: 'location_name', label: 'Club' },
  { key: 'subscription_end', label: 'Subscription end' },
  { key: 'is_active', label: 'Status' },
  { key: 'created_at', label: 'Registered' },
];

const RenderTable = ({
  members,
  showRestoreModal,
  showAdvancePaymentModal,
  showAdvanceDamageCharges,
  showEmailModal,
  showUpdateModal,
  showDeleteModal,
  showChangePackage,
  showChangeTrainer,
  showResetPasswordModal,
  packages,
  handleExport,
  searchQuery,
  serverPagination,
  onApplyFilters,
  onClearFilters,
  sortBy,
  sortDir,
  onSortChange,
  showTrainerColumns = false,
  tabType = 'all',
  onExportAll,
  onExportWithFilters,
  onExportCurrentView,
  isListFetching = false,
  filterParams: appliedFilterParams,
  exportHasFilters,
}) => {

  const [filterType, setFilterType] = useState('');
  const [filterValue, setFilterValue] = useState({});
  const [filteredMembers, setFilteredMembers] = useState(members);
  const [rowsPerPage, setRowsPerPage] = useState(serverPagination ? serverPagination.rowsPerPage : 10);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedPackage, setSelectedPackage] = useState("");
  const [selectedGender, setSelectedGender] = useState("");
  const [selectedFeeStatus, setSelectedFeeStatus] = useState("");
  const [selectedDiscount, setSelectedDiscount] = useState("");
  const [discountFrom, setDiscountFrom] = useState('');
  const [discountTo, setDiscountTo] = useState('');
  const [dateFilterHint, setDateFilterHint] = useState("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(serverPagination ? serverPagination.page : 0)
  const [selectedMember, setSelectedMember] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    if (!serverPagination || !appliedFilterParams) return;
    setFromDate(appliedFilterParams.from_date || "");
    setToDate(appliedFilterParams.to_date || "");
    setSelectedPackage(appliedFilterParams.package_id || "");
    setSelectedGender(appliedFilterParams.gender || "");
    setSelectedFeeStatus(appliedFilterParams.fee_status || "");
  }, [appliedFilterParams, serverPagination]);

  const hasFiltersApplied = useMemo(() => {
    if (serverPagination && exportHasFilters != null) {
      return exportHasFilters;
    }
    return !!(
      fromDate ||
      toDate ||
      selectedPackage ||
      selectedGender ||
      selectedFeeStatus ||
      discountFrom ||
      discountTo
    );
  }, [fromDate, toDate, selectedPackage, selectedGender, selectedFeeStatus, discountFrom, discountTo, serverPagination, exportHasFilters]);

  const sortedMembers = useMemo(() => {
    const list = filteredMembers || [];
    if (serverPagination) return list;
    return sortMembers(list, sortBy, sortDir);
  }, [filteredMembers, sortBy, sortDir, serverPagination]);

  const paginatedMembers = serverPagination
    ? (sortedMembers || [])
    : !sortedMembers || sortedMembers.length === 0
      ? []
      : rowsPerPage === -1
        ? sortedMembers
        : sortedMembers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  useEffect(() => {
    if (serverPagination) {
      setFilteredMembers(members || []);
      return;
    }
    const lowerQuery = (searchQuery || "").toLowerCase();
    const filtered = (members || []).filter((member) => {
      const combinedMemberID = `${member?.location_id?.member_id_temp || ""}${member?.member_id || ""}`.toLowerCase();
      const combinedPackageID = `${member?.package_id?.package_id_temp || ""}${member?.member_id ?? ""}`.toLowerCase();
      return (
        combinedMemberID?.includes(lowerQuery) ||
        combinedPackageID?.includes(lowerQuery) ||
        (member.name && member.name.toLowerCase().includes(lowerQuery)) ||
        (member.location_id?.name && member.location_id.name.toLowerCase().includes(lowerQuery)) ||
        (member?.address && member.address.toLowerCase().includes(lowerQuery)) ||
        (member?.phone && member.phone.toLowerCase().includes(lowerQuery)) ||
        (member.email && member.email.toLowerCase().includes(lowerQuery))
      );
    });
    setFilteredMembers(filtered);
  }, [searchQuery, members, serverPagination]);

  const handleSort = (columnKey, explicitDir) => {
    if (onSortChange) onSortChange(columnKey, explicitDir);
  };

  const handleChangePage = (event, newPage) => {
    if (serverPagination?.onPageChange) {
      serverPagination.onPageChange(event, newPage);
    } else {
      setPage(newPage);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    const newRows = parseInt(event.target.value, 10);
    if (serverPagination?.onRowsPerPageChange) {
      serverPagination.onRowsPerPageChange(event);
    } else {
      setRowsPerPage(newRows);
      setPage(0);
    }
  };

  const handleFilterChange = (value) => setFilterType(value);
  const handleFilterValueChange = (value) => {
    setFilterValue(value)
    setFilteredMembers(filterMembers(members, value))
  };
  function handlePrint(member) {
    navigate("/profilemember", { state: { id: member, prevPath: "/members" } });
  }
  const isMemberFeePaid = (member) => memberFeeChip(member).paid;

  const handleFilter = () => {
    if (serverPagination && onApplyFilters) {
      const hasPartialDate = (fromDate && !toDate) || (!fromDate && toDate);
      if (hasPartialDate) {
        setDateFilterHint("Select both From and To dates to filter by registration period.");
        return;
      }
      setDateFilterHint("");
      onApplyFilters({
        package_id: selectedPackage || "",
        gender: selectedGender || "",
        from_date: fromDate || "",
        to_date: toDate || "",
        fee_status: selectedFeeStatus || "",
        is_active: appliedFilterParams?.is_active || "",
      });
      return;
    }
    if (fromDate === '' && toDate === '' && selectedGender === '' && selectedPackage === '' && selectedFeeStatus === '' && searchQuery === '' && selectedDiscount === '' && discountFrom === '' && discountTo === '') {
      setFilteredMembers(members); // Reset to full list when all filters are empty
      return;
    }
    setLoading(true);
    let filtered = members || [];
    if (fromDate && toDate) {
      const startFilterDate = new Date(fromDate);
      startFilterDate.setHours(0, 0, 0, 0);
      const endFilterDate = new Date(toDate);
      endFilterDate.setHours(23, 59, 59, 999);
      filtered = filtered.filter((memb) => {
        const createdAt = new Date(memb.created_at);
        const updatedAt = memb.updated_at ? new Date(memb.updated_at) : null;
        return (
          (createdAt >= startFilterDate && createdAt <= endFilterDate) ||
          (updatedAt && updatedAt >= startFilterDate && updatedAt <= endFilterDate)
        );
      });
    }
    if (selectedPackage) {
      filtered = filtered.filter(memb => memb.package_id?._id === selectedPackage);
    }
    if (selectedGender) {
      filtered = filtered.filter(memb => memb.gender === selectedGender);
    }
    if (selectedFeeStatus === "paid") {
      filtered = filtered.filter((memb) => isMemberFeePaid(memb));
    } else if (selectedFeeStatus === "unpaid") {
      filtered = filtered.filter((memb) => !isMemberFeePaid(memb));
    }
    if (discountFrom && discountTo) {
      filtered = filtered.filter(memb =>
        memb.discount >= Number(discountFrom) && memb.discount <= Number(discountTo)
      );
    }
    setFilteredMembers(filtered);
    setTimeout(() => setLoading(false), 500);
  };

  const handleClearFilters = () => {
    if (serverPagination && onClearFilters) {
      setDateFilterHint("");
      setFromDate("");
      setToDate("");
      setSelectedPackage("");
      setSelectedGender("");
      setSelectedFeeStatus("");
      setSelectedDiscount("");
      setDiscountFrom("");
      setDiscountTo("");
      onClearFilters();
      return;
    }
    if (fromDate === '' && toDate === '' && selectedGender === '' && selectedPackage === '' && selectedFeeStatus === '' && discountFrom === '' && discountTo === '') {
      return;
    }
    setLoading(true);
    setFromDate("");
    setToDate("");
    setSelectedPackage("");
    setSelectedGender("");
    setSelectedFeeStatus("");
    setSelectedDiscount("");
    setDiscountFrom("");
    setDiscountTo("");
    setFilteredMembers(members);
    setTimeout(() => setLoading(false), 1000);
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event, member) => {
    setAnchorEl(event.currentTarget);
    setSelectedMember(member);
  }
  const handleClose = () => {
    setAnchorEl(null);
    setSelectedMember(null);
  };

  const renderActions = (member) => (
    <div className="flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
      {!member.is_active && !member.is_new ? (
        <Tooltip title="Restore member" arrow>
          <IconButton
            size="small"
            onClick={() => showRestoreModal(member)}
            aria-label="Restore member"
          >
            <RestoreIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ) : null}
      <Tooltip title="View dossier" arrow>
        <IconButton
          size="small"
          onClick={() => handlePrint(member)}
          aria-label="View member dossier"
        >
          <VisibilityIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="More actions" arrow>
        <IconButton
          size="small"
          onClick={(event) => handleClick(event, member)}
          aria-label="Member actions"
        >
          <MoreVertIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </div>
  );

  const formatMaybeDate = (value) => {
    if (!value) return "—";
    const d = dayjs(value);
    return d.isValid() ? d.format("MMM DD, YYYY") : "—";
  };

  const memberCode = (member) =>
    `${member?.location_id?.member_id_temp || ""}${member?.member_id || ""}` || "—";

  const packageCode = (member) =>
    member?.package_id
      ? `${member.package_id?.package_id_temp ?? ""}${member.member_id ?? ""}`
      : "—";

  const controlClass =
    "w-full border border-gx-border bg-gx-surface rounded-gx-control py-2 px-3 outline-0 text-sm text-gx-ink";

  return (
    <>
      <div className="w-full">
        <div className="px-5 pt-5 pb-4 border-b border-gx-border bg-gx-canvas/50">
          <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
            <div>
              <p className="text-xs font-semibold uppercase tracking-wide text-gx-ink-soft">Filters</p>
              <p className="text-sm text-gx-ink">Narrow the roster without leaving this view.</p>
            </div>
            <div className="flex items-center gap-3 print:hidden">
              <label className="text-xs font-semibold uppercase tracking-wide text-gx-ink-soft">
                Sort
                <select
                  className={`${controlClass} mt-1.5 w-44`}
                  value={sortBy || ""}
                  onChange={(e) => {
                    const nextKey = e.target.value;
                    if (!nextKey) {
                      handleSort(null, null);
                      return;
                    }
                    handleSort(nextKey, sortBy === nextKey && sortDir ? sortDir : "asc");
                  }}
                >
                  <option value="">Default</option>
                  {SORT_OPTIONS.map((opt) => (
                    <option key={opt.key} value={opt.key}>{opt.label}</option>
                  ))}
                  {showTrainerColumns ? (
                    <option value="trainer_name">Trainer</option>
                  ) : null}
                </select>
              </label>
              <button
                type="button"
                className="gx-cta-secondary mt-5"
                disabled={!sortBy}
                onClick={() => {
                  if (!sortBy) return;
                  handleSort(sortBy, sortDir === "asc" ? "desc" : "asc");
                }}
              >
                {sortDir === "desc" ? "Z–A" : sortDir === "asc" ? "A–Z" : "Order"}
              </button>
              {hasPermission(getSessionUser(), 'members:export') && (
                <ExportDropdownMenu
                  onExportAll={() => onExportAll?.(members)}
                  onExportWithFilters={() => onExportWithFilters?.(filteredMembers, filterValue)}
                  onExportCurrentView={() => onExportCurrentView?.(paginatedMembers, filterValue)}
                  hasFilters={hasFiltersApplied}
                  className="text-gx-navy hover:text-gx-teal mt-5"
                />
              )}
            </div>
          </div>
          <form onSubmit={(e) => e.preventDefault()} className="space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
              <label className="text-xs font-semibold uppercase tracking-wide text-gx-ink-soft">
                From date
                <input
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  className={`${controlClass} mt-1.5`}
                />
              </label>
              <label className="text-xs font-semibold uppercase tracking-wide text-gx-ink-soft">
                To date
                <input
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  disabled={!fromDate}
                  min={fromDate}
                  className={`${controlClass} mt-1.5 ${!fromDate ? "bg-gx-canvas text-gx-ink-soft cursor-not-allowed" : ""}`}
                />
              </label>
              <label className="text-xs font-semibold uppercase tracking-wide text-gx-ink-soft">
                Discount from
                <input
                  className={`${controlClass} mt-1.5`}
                  type="number"
                  value={discountFrom}
                  onChange={(e) => setDiscountFrom(e.target.value)}
                />
              </label>
              <label className="text-xs font-semibold uppercase tracking-wide text-gx-ink-soft">
                Discount to
                <input
                  className={`${controlClass} mt-1.5`}
                  type="number"
                  value={discountTo}
                  onChange={(e) => setDiscountTo(e.target.value)}
                />
              </label>
              <label className="text-xs font-semibold uppercase tracking-wide text-gx-ink-soft">
                Package
                <select
                  className={`${controlClass} mt-1.5`}
                  value={selectedPackage}
                  onChange={(e) => setSelectedPackage(e.target.value)}
                >
                  <option value="">All packages</option>
                  {packages && packages?.map((pckg) => (
                    <option key={pckg._id} value={pckg._id}>
                      {pckg.title}
                    </option>
                  ))}
                </select>
              </label>
              <label className="text-xs font-semibold uppercase tracking-wide text-gx-ink-soft">
                Gender
                <select
                  className={`${controlClass} mt-1.5`}
                  value={selectedGender}
                  onChange={(e) => setSelectedGender(e.target.value)}
                >
                  <option value="">All genders</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other">Other</option>
                </select>
              </label>
              <label className="text-xs font-semibold uppercase tracking-wide text-gx-ink-soft">
                Fee
                <select
                  className={`${controlClass} mt-1.5`}
                  value={selectedFeeStatus}
                  onChange={(e) => setSelectedFeeStatus(e.target.value)}
                >
                  <option value="">All fees</option>
                  <option value="paid">Paid</option>
                  <option value="unpaid">Unpaid</option>
                </select>
              </label>
            </div>
            {dateFilterHint ? (
              <p className="text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-gx px-3 py-2">
                {dateFilterHint}
              </p>
            ) : null}
            <div className="flex flex-wrap gap-2">
              <button type="button" onClick={handleFilter} className="gx-cta">
                Apply filters
              </button>
              <button type="button" className="gx-cta-secondary" onClick={handleClearFilters}>
                Clear
              </button>
            </div>
          </form>
        </div>

        {!serverPagination && loading ? (
          <div className="flex justify-center items-center py-20 relative">
            <svg width="0" height="0">
              <defs>
                <linearGradient id="gradientColors" x1="1" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#D71920" />
                  <stop offset="100%" stopColor="#F7931E" />
                </linearGradient>
              </defs>
            </svg>
            <CircularProgress
              thickness={4}
              size={35}
              sx={{ "svg circle": { stroke: "url(#gradientColors)" } }}
            />
          </div>
        ) : filteredMembers && filteredMembers.length ? (
          <div className="relative">
            {serverPagination && isListFetching ? (
              <div
                className="absolute inset-0 z-10 flex items-center justify-center bg-gx-surface/70 backdrop-blur-[1px]"
                aria-busy="true"
                aria-live="polite"
              >
                <CircularProgress thickness={4} size={36} className="!text-gx-navy" />
              </div>
            ) : null}
            <div className="p-5 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
              {paginatedMembers.map((member, index) => {
                const start = member?.subscription?.renewed_date || member?.subscription?.start_date;
                const end = member?.subscription?.end_date;
                const feeChip = memberFeeChip(member);
                const photoSrc = encodedImagesURI(member.photo);
                return (
                  <article
                    key={member?._id || index}
                    className="group rounded-gx border border-gx-border bg-gx-canvas/40 hover:bg-gx-surface hover:border-gx-navy/25 hover:shadow-gx transition overflow-hidden"
                  >
                    <div className="h-1 bg-gradient-to-r from-[#D71920] to-[#F7931E]" />
                    <div className="p-4">
                      <div className="flex items-start gap-3">
                        <button
                          type="button"
                          className="flex items-start gap-3 text-left min-w-0 flex-1"
                          onClick={() => handlePrint(member)}
                        >
                          <div className="w-14 h-14 rounded-gx overflow-hidden border border-gx-border shrink-0 bg-gx-canvas">
                            {photoSrc ? (
                              <img
                                src={photoSrc}
                                alt={member.name}
                                className="w-full h-full object-cover"
                                onError={(e) => (e.target.src = defaultUser)}
                              />
                            ) : (
                              <div className="w-full h-full flex items-center justify-center text-sm font-semibold text-gx-navy bg-gx-navy/10">
                                {initials(member?.name)}
                              </div>
                            )}
                          </div>
                          <div className="min-w-0">
                            <p className="font-semibold text-gx-ink truncate">{member?.name || "—"}</p>
                            <p className="text-xs text-gx-ink-soft truncate">{memberCode(member)}</p>
                            {member?.address ? (
                              <p className="text-xs text-gx-ink-soft truncate">{member.address}</p>
                            ) : null}
                            <div className="flex flex-wrap gap-1 mt-2">
                              <StatusChip active={!!member.is_active} />
                              <StatusChip tone={feeChip.tone} label={feeChip.label} />
                            </div>
                          </div>
                        </button>
                        {renderActions(member)}
                      </div>
                      <dl className="mt-4 grid grid-cols-2 gap-3 text-sm">
                        <div>
                          <dt className="text-[11px] font-semibold uppercase tracking-wide text-gx-ink-soft">Phone</dt>
                          <dd className="text-gx-ink truncate">{member?.phone || "—"}</dd>
                        </div>
                        <div>
                          <dt className="text-[11px] font-semibold uppercase tracking-wide text-gx-ink-soft">Club</dt>
                          <dd className="text-gx-ink truncate">{member?.location_id?.name || "—"}</dd>
                        </div>
                        <div>
                          <dt className="text-[11px] font-semibold uppercase tracking-wide text-gx-ink-soft">Package</dt>
                          <dd className="text-gx-ink truncate">{member?.package_id?.title || "—"}</dd>
                          <dd className="text-xs text-gx-ink-soft truncate">{packageCode(member)}</dd>
                        </div>
                        <div>
                          <dt className="text-[11px] font-semibold uppercase tracking-wide text-gx-ink-soft">Subscription</dt>
                          <dd className="text-gx-ink">{formatMaybeDate(start)}</dd>
                          <dd className="text-xs text-gx-ink-soft">to {formatMaybeDate(end)}</dd>
                        </div>
                        {showTrainerColumns ? (
                          <div className="col-span-2">
                            <dt className="text-[11px] font-semibold uppercase tracking-wide text-gx-ink-soft">Trainer</dt>
                            <dd className="text-gx-ink truncate">{member.trainer_id?.name || "—"}</dd>
                          </div>
                        ) : null}
                      </dl>
                    </div>
                  </article>
                );
              })}
            </div>
            <div className="border-t border-gx-border px-2">
              <TablePagination
                component="div"
                rowsPerPageOptions={serverPagination ? [5, 10, 25, 50, 100] : [5, 10, 25, { label: "All", value: -1 }]}
                count={serverPagination ? serverPagination.total : filteredMembers.length}
                rowsPerPage={serverPagination ? serverPagination.rowsPerPage : rowsPerPage}
                page={serverPagination ? serverPagination.page : page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </div>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem
                onClick={() => {
                  const member = selectedMember;
                  handleClose();
                  showAdvancePaymentModal(member);
                }}
              >
                <ListItemIcon>
                  <AttachMoneyIcon />
                </ListItemIcon>
                <ListItemText primary="Advance Payment" />
              </MenuItem>
              <MenuItem
                onClick={() => {
                  const member = selectedMember;
                  handleClose();
                  showAdvanceDamageCharges(member);
                }}
              >
                <ListItemIcon>
                  <PaidIcon />
                </ListItemIcon>
                <ListItemText primary="Damage Charges" />
              </MenuItem>
              {hasPermission(getSessionUser(), 'members:update') && (
              <MenuItem
                onClick={() => {
                  const member = selectedMember;
                  handleClose();
                  showUpdateModal(member);
                }}
              >
                <ListItemIcon>
                  <EditIcon />
                </ListItemIcon>
                <ListItemText primary="Update" />
              </MenuItem>
              )}
              <MenuItem
                onClick={() => {
                  const member = selectedMember;
                  handleClose();
                  showChangePackage(member);
                }}
              >
                <ListItemIcon>
                  <WalletIcon />
                </ListItemIcon>
                <ListItemText primary="Change Package" />
              </MenuItem>
              <MenuItem
                onClick={() => {
                  const member = selectedMember;
                  handleClose();
                  showChangeTrainer(member);
                }}
              >
                <ListItemIcon>
                  <SupervisorAccountIcon />
                </ListItemIcon>
                <ListItemText primary="Change Trainer" />
              </MenuItem>
              {typeof showResetPasswordModal === "function" && (
                <MenuItem
                  onClick={() => {
                    const member = selectedMember;
                    handleClose();
                    showResetPasswordModal(member);
                  }}
                >
                  <ListItemIcon>
                    <LockResetIcon />
                  </ListItemIcon>
                  <ListItemText primary="Reset Password" />
                </MenuItem>
              )}
              <MenuItem
                onClick={() => {
                  const member = selectedMember;
                  handleClose();
                  if (member?.subscription?._id) {
                    navigate(`/vouchers/${member.subscription._id}`);
                  }
                }}
              >
                <ListItemIcon>
                  <ConfirmationNumberIcon />
                </ListItemIcon>
                <ListItemText primary="Vouchers" />
              </MenuItem>
            </Menu>
          </div>
        ) : serverPagination && isListFetching ? (
          <div className="flex justify-center items-center py-20" aria-busy="true">
            <CircularProgress thickness={4} size={35} className="!text-gx-navy" />
          </div>
        ) : (
          <EmptyState
            title="No members match"
            description="Try another tab, clear filters, or add a member to this roster."
          />
        )}
      </div>
    </>
  )
};

export default RenderTable;
